import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

/**
 * Service axios untuk INM — Penundaan Operasi Elektif.
 * Base URL: /api/v1/ibs/elective-postponement
 */

const BASE = "/ibs/elective-postponement";

// --- Reason Definitions ---

async function getReasonDefinitions() {
  const response = await http
    .getData(`${BASE}/reason-definitions`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// --- Event CRUD ---

async function getEvents(params?: any) {
  const response = await http
    .getDataParam(`${BASE}/events`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getEvent(id: number) {
  const response = await http
    .getData(`${BASE}/events/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function createEvent(data: any) {
  const response = await http
    .postData(`${BASE}/events`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateEvent(id: number, data: any) {
  const response = await http
    .putData(`${BASE}/events/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteEvent(id: number) {
  const response = await http
    .deleteData(`${BASE}/events/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function rescoreEvent(id: number) {
  const response = await http
    .postData(`${BASE}/events/${id}/rescore`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// --- Recap & Dashboard ---

async function getDailyRecap(params: { tanggal?: string; unit_kamar_operasi?: string }) {
  const response = await http
    .getDataParam(`${BASE}/daily-recap`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getDashboard(params: { tanggal?: string; unit_kamar_operasi?: string }) {
  const response = await http
    .getDataParam(`${BASE}/dashboard`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// --- 3-Tier Signing ---

async function signEvent(id: number, tier: "petugas" | "ka_instalasi" | "approver", signedNama: string) {
  const response = await http
    .putData(`${BASE}/events/${id}/sign`, { tier, signed_nama: signedNama })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// --- Reports ---

async function getPeriodicReports(params?: any) {
  const response = await http
    .getDataParam(`${BASE}/reports/periodic`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function generateMonthlyReport(data: {
  bulan: number;
  tahun: number;
  unit_kamar_operasi?: string;
}) {
  const response = await http
    .postData(`${BASE}/reports/generate-monthly`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getAllPeriods(params: { tanggal?: string; unit_kamar_operasi?: string }) {
  const response = await http
    .getDataParam(`${BASE}/reports/all-periods`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getPareto(params: {
  bulan?: number;
  kuartal?: number;
  tahun: number;
  unit_kamar_operasi?: string;
}) {
  const response = await http
    .getDataParam(`${BASE}/reports/pareto`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getQuarterlyAnalyses(params?: any) {
  const response = await http
    .getDataParam(`${BASE}/reports/quarterly`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function generateQuarterlyAnalysis(data: {
  kuartal: number;
  tahun: number;
  unit_kamar_operasi?: string;
}) {
  const response = await http
    .postData(`${BASE}/reports/generate-quarterly`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// --- PDF ---

async function getScheduleCandidates(params?: any) {
  const response = await http
    .getDataParam(`${BASE}/schedule-candidates`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function getPdfUrl(id: number): string {
  return `${http.apiUrl}${BASE}/events/${id}/pdf`;
}

export default {
  // Reasons
  getReasonDefinitions,
  // Events CRUD
  getEvents,
  getEvent,
  createEvent,
  updateEvent,
  deleteEvent,
  rescoreEvent,
  // Jadwal operasi elektif
  getScheduleCandidates,
  // Recap & Dashboard
  getDailyRecap,
  getDashboard,
  // Signing
  signEvent,
  // Reports
  getPeriodicReports,
  generateMonthlyReport,
  getAllPeriods,
  getPareto,
  getQuarterlyAnalyses,
  generateQuarterlyAnalysis,
  // PDF
  getPdfUrl,
};
